import { render, staticRenderFns } from "./agent-table.vue?vue&type=template&id=b3623b06&"
import script from "./agent-table.vue?vue&type=script&lang=js&"
export * from "./agent-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports